// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileUnknownOutlinedSvg from "@ant-design/icons-svg/es/asn/FileUnknownOutlined";
import AntdIcon from '../components/AntdIcon';

var FileUnknownOutlined = function FileUnknownOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileUnknownOutlinedSvg
  }));
};

FileUnknownOutlined.displayName = 'FileUnknownOutlined';
export default React.forwardRef(FileUnknownOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FileUnknownOutlined.js
// module id = 1153
// module chunks = 0